<div class="page-container">
    <div class="container p-5 text-center">
        <span class="title">{{currentConference.name}}</span>
    </div>
</div>